// This file was automatically generated from uiwidget.FileUploader.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.FileUploader');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.FileUploader.uploadFileForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="upload-file-content fl ebs-pull-left"><form class="upload-file-form el8Form">', (! opt_data.isImage) ? '<button ' + ((opt_data.isDisabled) ? 'disabled' : '') + ' class="' + soy.$$escapeHtml(opt_data.buttonClass ? opt_data.buttonClass : 'el8UploadButton') + '"><span class="el8IconUpload"></span>' + soy.$$escapeHtml(opt_data.buttonText ? opt_data.buttonText : 'Upload Files') + '</button>' : '', '<input ', (opt_data.isDisabled) ? 'disabled' : '', ' class="el8UploadHiddenInput" ', (opt_data.inputWidth || opt_data.inputHeight) ? 'style="' + ((opt_data.inputWidth) ? 'width:' + soy.$$escapeHtml(opt_data.inputWidth) + 'px;' : '') + ((opt_data.inputHeight) ? 'height:' + soy.$$escapeHtml(opt_data.inputHeight) + 'px;' : '') + '" ' : '', 'type="file" name="uploadedFile" ', (opt_data.multiFile) ? 'multiple' : '', ' /></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.FileUploader.uploadFileEntry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8SectionUploadQueueItem upload-file-entry frame ', (opt_data.processState == 'error') ? 'el8FailedFile' : '', '" ', (opt_data.id) ? 'data-id="' + soy.$$escapeHtml(opt_data.id) + '"' : '', '>', (opt_data.processState == 'uploading') ? '<span class="el8UploadingFile"><p class= "el8FloatLeft ebs-pull-left">' + soy.$$escapeHtml(opt_data.originalFilename) + '</p><span class="el8FloatRight ebs-pull-right el8UploadQueueProgress progress-indicator">--</span><p class="el8FloatRight el8UploadQueueStatus">uploading</p></span>' : (opt_data.processState == 'pending' || opt_data.processState == 'processing') ? '<span class="el8ProcessingFile"><p class= "el8FloatLeft ebs-pull-left">' + soy.$$escapeHtml(opt_data.originalFilename) + '</p>' + ((opt_data.percentProgress) ? '<span class="el8FloatRight el8UploadQueueProgress progress-indicator">' + soy.$$escapeHtml(opt_data.percentProgress) + '%</span>' : '<img class="el8UploadQueueIcon" src="/static/images/processing_666.gif" />') + '<p class="el8FloatRight ebs-pull-right el8UploadQueueStatus">processing</p></span>' : (opt_data.processState == 'complete') ? '<span class="el8CompletedFile"><p class= "el8FloatLeft ebs-pull-left">' + soy.$$escapeHtml(opt_data.originalFilename) + '</p><p class="el8FloatRight ebs-pull-right el8UploadQueueStatus">completed</p><img class="el8UploadQueueIcon" src="/static/images/icon-complete.png" /></span>' : '<span class="el8FailedFile"><p class= "el8FloatLeft ebs-pull-left">' + soy.$$escapeHtml(opt_data.originalFilename) + '</p><p class="el8FloatRight ebs-pull-right el8UploadQueueStatus">failed, try again</p><img class="el8UploadQueueIcon" src="/static/images/icon-fail.png" /><a class="upload-remove-trigger el8DismissFailedFileIcon" data-id="' + soy.$$escapeHtml(opt_data.id) + '">x</a></span>', '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.FileUploader.droppableZone = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.msg) ? '<p class="' + soy.$$escapeHtml(opt_data.overlayClass) + '">' + soy.$$escapeHtml(opt_data.msg) + '</p>' : '<div class="' + soy.$$escapeHtml(opt_data.overlayClass) + '"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.FileUploader.hoverOverlay = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="', soy.$$escapeHtml(opt_data.overlayClass), '"></div>');
  if (!opt_sb) return output.toString();
};
